
@let _params = params();

@if (_params != null) {

    <app-form-viewer [init]="_params">

    </app-form-viewer>

}